import { jbColors } from 'theme/jbColors';

const MuiTableRow = {
  styleOverrides: {
    root: {
      cursor: 'pointer' as const,
      borderBottom: `1px solid #CCCCCC`,
      '&$selected, &$selected:hover': {
        backgroundColor: jbColors.core.stone[10],
      },
      '&&[class*="selected"]': {
        backgroundColor: jbColors.core.stone[20],
      },
    },
  },
};

export default MuiTableRow;
